import {INITIAL_STATE} from './';
import {ActionTypes} from '../actions/action-types';
import {explodeFolders, FolderTypes, gatherFolderIds, removeAttributesFromFolders} from '../services/folder';

function _updateFolder(folderToReplace, folders) {
 if (!folders || !folders.length > 0) {
    return [];
  }
  return folders.map(f => {
    // Copia los hijos recursivamente SIN mutar el objeto original
    const children = f.children && f.children.length > 0
      ? _updateFolder(folderToReplace, f.children)
      : [];

    if (f.folderId === folderToReplace.folderId) {
      // Mantén el atributo trash si corresponde
      let updatedFolder = { ...folderToReplace };
      if (f.type === FolderTypes.TRASH && folderToReplace.type !== FolderTypes.TRASH) {
        updatedFolder = {
          ...updatedFolder,
          attributes: [...updatedFolder.attributes, FolderTypes.TRASH.attribute],
          type: FolderTypes.TRASH
        };
      }
      // Usa los children del folder actualizado (los nuevos), no los viejos calculados arriba
      return { ...updatedFolder };
    }
    return { ...f, children };
  });
}

const _deleteChildFolder = toDeleteFolderId => {
  const deleteChildFolderFunction = folder => {
    if (Array.isArray(folder.children)) {
      folder.children = folder.children.filter(child => child.folderId !== toDeleteFolderId);
      folder.children.forEach(deleteChildFolderFunction);
    }
  };
  return deleteChildFolderFunction;
};

const folders = (state = INITIAL_STATE.folders, action = {}) => {
  switch (action.type) {
    case ActionTypes.FOLDERS_BE_REQUEST:
      return {...state, activeRequests: state.activeRequests + 1};
    case ActionTypes.FOLDERS_BE_REQUEST_RESET:
      return {...state, activeRequests: 0};
    case ActionTypes.SET_FIRST_SYNC_IMAP: {
      return {
        ...state,
        firstSyncCompleted: action.payload
      };
    }
    case ActionTypes.FOLDERS_SET: {
      const newItems = [...action.payload];
      return {
        ...state,
        items: removeAttributesFromFolders(newItems.map(folder => (
          {...folder}
        ))),
        explodedItems: explodeFolders(newItems),
        activeRequests: state.activeRequests > 0 ? state.activeRequests - 1 : 0
      };
    }
    case ActionTypes.FOLDERS_UPDATE_PARENT_ONLY: {
      const newUpdateState = {...state};
      // const isParentNode = state.items[0].folderId === action.payload.folderId
      // if (!isParentNode){
      //   newUpdateState.items = removeAttributesFromFolders(_updateFolder(action.payload, newUpdateState.items));
      // }

      // Update changed folders
      newUpdateState.explodedItems = {...newUpdateState.explodedItems};
      newUpdateState.explodedItems[action.payload.folderId] = action.payload;
      // Remove any deleted folder
      const remainingFolderIds = Object.keys(explodeFolders(newUpdateState.items));
      Object.keys(newUpdateState.explodedItems)
        .filter(key => !remainingFolderIds.includes(key))
        .forEach(key => delete newUpdateState.explodedItems[key]);
      return newUpdateState;
    }
    case ActionTypes.FOLDERS_UPDATE: {
      const newUpdateState = {...state};
      newUpdateState.items = removeAttributesFromFolders(_updateFolder(action.payload, newUpdateState.items));
      // Update changed folders
      newUpdateState.explodedItems = {...newUpdateState.explodedItems, ...explodeFolders([action.payload])};
      // Remove any deleted folder
      const remainingFolderIds = Object.keys(explodeFolders(newUpdateState.items));
      Object.keys(newUpdateState.explodedItems)
        .filter(key => !remainingFolderIds.includes(key))
        .forEach(key => delete newUpdateState.explodedItems[key]);
      return newUpdateState;
    }
    /**
     * Once a folder is renamed, previous references to that folder should be removed from the tree and exploded
     * tree state.
     * Other actions will have already taken care of adding the renamed folder to the new position, this action
     * is only responsible for the removal process.
     * This action should be triggered whenever a folder is renamed or moved within a mailbox.
     */
    case ActionTypes.APPLICATION_FOLDER_RENAME_OK: {
      const newState = {...state};
      // Remove previous folder from Tree
      const {oldFolderId} = action.payload;
      if (Object.keys(newState.explodedItems).includes(oldFolderId)) {
        // Delete from Exploded list (Parent + Children)
        gatherFolderIds(newState.explodedItems[oldFolderId]).forEach(
          folderToDeleteId => delete newState.explodedItems[folderToDeleteId]);

        // Delete from tree (root folders)
        newState.items = newState.items.filter(item => item.folderId !== oldFolderId);
        // Delete from tree (child folders)
        newState.items.forEach(_deleteChildFolder(oldFolderId));
      }
      return newState;
    }
    case ActionTypes.FOLDERS_SET_SHOW_MOVE_FOLDER_ALERT:
      return {...state, showMoveFolderAlert: action.payload};
    case ActionTypes.FOLDERS_SET_IS_UPDATED_FOLDER:
      return {...state, isUpdatedFolder: action.payload};
    case ActionTypes.FOLDERS_SET_SHOW_FOLDER_LIST:
      return {...state, showFolderList: action.payload};
    default:
      return state;
  }
};

export default folders;
